define(
    [
        "scripts/utils/bindings/datetimepicker",
        "scripts/utils/bindings/multiselect",
        "scripts/utils/bindings/multiInput",
        "scripts/utils/bindings/tooltipster",
        "scripts/utils/bindings/onEnter",
        "scripts/utils/bindings/numberFormat"
    ],
    function() {});